"use client";

import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const facts = ["Real-time pattern recognition across multiple timeframes.", "Objective analysis devoid of emotional bias.", "Structured decision-making frameworks for every trade."];
const caddieFeatures = [{
  title: "Trust Mechanic",
  description: "Establishes baseline confidence levels for identified setups before execution, ensuring alignment with your systematic rules."
}, {
  title: "Error Log",
  description: "Systematically records deviations from the trading plan to refine future performance and build unshakeable discipline."
}, {
  title: "Risk Protocol",
  description: "Calculates optimal position sizing based on account equity and strict stop-loss parameters to preserve capital."
}, {
  title: "Pattern Library",
  description: "Cross-references current market structures against 16 predefined slot types for rapid, accurate identification."
}];
export default function AiAssistance() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ai-assistance" className="dark bg-background text-foreground py-24 px-6 lg:px-12 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-start">
          
          {}
          <div className={`lg:col-span-5 lg:sticky lg:top-32 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="mb-6">
              <h2 className="font-sans text-primary text-sm tracking-widest uppercase mb-4">
                The AI Caddie
              </h2>
              <div className="w-12 h-0.5 bg-primary mb-8"></div>
            </div>
            
            <blockquote className="font-serif text-2xl md:text-3xl italic text-foreground leading-relaxed mb-12">
              "The Caddie doesn't swing the club for you. It reads the wind, calculates the distance, and hands you the right iron. The execution is yours."
            </blockquote>

            <ul className="space-y-6">
              {facts.map((fact, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  {}
                  <div className="w-2 h-2 bg-primary rotate-45 mt-2.5 shrink-0" aria-hidden="true" />
                  <span className="font-serif text-lg text-muted-foreground leading-relaxed">
                    {fact}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className={`lg:col-span-7 flex flex-col gap-6 transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {caddieFeatures.map((feature, i) => <Card key={i} data-index={i} className="rounded-none border-0 border-l border-primary bg-card shadow-none hover:bg-card/80 transition-colors duration-300">
                <CardHeader className="pb-2">
                  <CardTitle className="font-sans text-primary text-sm tracking-widest uppercase">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-serif text-foreground text-lg leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>

        </div>
      </div>
    </section>;
}